import { Translate } from '@chipinside/translate'
import { LinearProgress, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

import { Icon } from '#/components/Icon'
import { ContextLoaderOptions } from '#/contexts/Loader/types'

const Wrapper = styled(`div`)({
  '& > svg': {
    width: '200px',
  },
  'alignItems': 'center',
  'display': 'flex',
  'flexDirection': 'column',
  'height': '100%',
  'justifyContent': 'center',
  'width': '100%',
  'zIndex': '1000000',
})

const Title = styled(Typography)({
  display: 'flex',
  fontSize: 12,
  gap: '2px',
  lineHeight: '2',
  margin: '24px 8px 8px',
  maxWidth: 'min(600px, 100%)',
  textAlign: 'center',
})

const Subtitle = styled(Typography)({
  color: '#666',
  fontSize: 11,
  lineHeight: '2',
  margin: '8px',
  maxWidth: 'min(600px, 100%)',
  textAlign: 'center',
})

export const Ellipses = () => {
  return (
    <div className="ellipse">
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </div>
  )
}
export function PageLoader({ ellipsis, error, loading, subtitle, title }: ContextLoaderOptions) {
  const Progress = () => {
    if (error) {
      return (
        <LinearProgress
          value={100}
          variant={'determinate'}
          sx={{ maxWidth: '100%', width: '200px' }}
          color={'error'}
        />
      )
    }
    return <LinearProgress sx={{ maxWidth: '100%', width: '200px' }} />
  }

  return loading ? (
    <Wrapper>
      <Icon
        size="large"
        name="logo"
        color="primary"
        style={{ fontSize: 160, height: 'auto', maxWidth: '50%' }}
      />
      <Title variant="overline">
        {title ?? Translate({ messageKey: 'loading' })}
        {ellipsis && <Ellipses />}
      </Title>
      <Progress />
      <Subtitle variant="overline">
        {subtitle ?? Translate({ messageKey: 'loading_wait_a_moment' })}
      </Subtitle>
    </Wrapper>
  ) : null
}
